import { render, staticRenderFns } from "./PlazosCard.vue?vue&type=template&id=17e33f08"
import script from "./PlazosCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PlazosCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports